import removeInert from "./removeInert";

/**
 * This function replaces the default elementor arrow icon from FontAwesome to
 * the one used in the client's branding.
 */
const paginationTweaker = () => {
    formatPagination();

    // look for AJAX reload
    // Select the target node to observe (e.g., a specific container where AJAX content is loaded)
    var targetNode = document.querySelector('.elementor-widget-loop-grid[data-settings*="pagination_type"]');

    // Options for the observer (which mutations to observe)
    var config = { childList: true, subtree: true };

    // Callback function to execute when mutations are observed
    var callback = function(mutationsList, observer) {
        for (var mutation of mutationsList) {
            if (mutation.type === 'childList') {
                // Temporarily disconnect the observer to avoid infinite loop
                observer.disconnect();

                // Call the format function
                formatPagination();

                // Reconnect the observer
                observer.observe(targetNode, config);
                break;
            }
        }
    };

    // Create an observer instance linked to the callback function
    var observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    if( targetNode ) {
        observer.observe(targetNode, config);
    }
};

function formatPagination() {
    const paginations = document.querySelectorAll('nav.elementor-pagination');
    if( paginations.length ) {
        paginations.forEach(pagination => {
            pagination.childNodes.forEach(page => {
                if( page.innerHTML === undefined ) return;
                // get only the numeric part, not the screenReader span
                let pageValue = removeSpan(page.innerHTML);
                if( isDigit(pageValue) ) {
                    // format page to be two-digit (adding the screenReader span)
                    page.innerHTML = `<span class="elementor-screen-only">Página</span>${formatNumber(pageValue)}`;
                } else if( page.classList.contains('dots') ) {
                    // Change the ... for a |
                    page.innerHTML = `|`;
                }
            });
        });
    }

}
function formatNumber(number) {
    return number < 10 ? '0' + number : number.toString();
}
function isDigit(content) {
    return /^\d+$/.test(content);
}
function removeSpan(str) {
    // Define the regular expression to match the specific span
    const spanRegex = /<span class="elementor-screen-only">Página<\/span>/;

    // Check if the span is present in the string
    if (spanRegex.test(str)) {
        // Remove the span from the string
        return str.replace(spanRegex, '');
    }

    // Return the original string if the span is not found
    return str;
}

export default paginationTweaker;